import React from 'react';
import { Button, Col, Radio, Row, Tag, Tooltip } from 'antd';
import style from './style.less';
import { COLOR } from '@/utils/color';

const getTooltipTitle = (key, isDisabled) => {
  switch (key) {
    case 'advanced':
      if (isDisabled) return 'Coming Soon';
      return 'Advanced protection level';
    case 'basic':
      return 'Basic protection level';
    default:
      return '';
  }
};

const ModeCards = ({ isLastIndex, data, modeCheckbox, setModeCheckbox, isDisabled = false }) => {
  const { title, description, subDescription, key, status } = data;

  const handleAction = (e, newValue) => {
    // Check if the event is from a radio button
    if (e.target && e.target.value) {
      // It's a radio change
      e.stopPropagation();
      setModeCheckbox(e.target.value);
    } else {
      // It's a row click
      if (!isDisabled) {
        setModeCheckbox(newValue);
      }
    }
  };

  return (
    <>
      {
        <Tooltip title={getTooltipTitle(key, isDisabled)}>
          <Row
            className={style.cardMain}
            style={{
              marginBottom: isLastIndex ? 0 : 30,
              color: isDisabled ? '#d8d8d8' : '',
              background: isDisabled ? '#fafafa' : '',
              cursor: isDisabled ? 'not-allowed' : 'pointer',
            }}
            onClick={e => handleAction(e, key)}
          >
            <Col span={2}>
              <Radio.Group
                disabled={isDisabled}
                value={modeCheckbox}
                onChange={e => handleAction(e)}
              >
                <Radio value={key} />
              </Radio.Group>
            </Col>
            <Col span={22}>
              <div className={style.headerContainer}>
                <h6 className={style.title}>{title}</h6>
                {isDisabled && <Tag color="#3AA0FF">Coming Soon</Tag>}
              </div>
              <p dangerouslySetInnerHTML={{ __html: description }} />
              <p
                dangerouslySetInnerHTML={{ __html: subDescription }}
                className={style.subDescription}
              />
            </Col>
          </Row>
        </Tooltip>
      }
    </>
  );
};

export default ModeCards;
